export default __webpack_public_path__ + "static/media/mark-sheet-template-4.ff186934.png";